/**
 * Sub menu
 */

/**
 * Sub menu toggle
 */
const componentSubMenuToggle = () => {
  const wrapper = document.querySelector('.js-sub-menu-mobile');
  const toggle = document.querySelector('.js-sub-menu-mobile-toggle');
  const tooltip = document.querySelector('.js-sub-menu-mobile-tooltip');
  if (!wrapper || !toggle || !tooltip) return;
  tippy(toggle, {
    content: tooltip.innerHTML,
    allowHTML: true,
    interactive: true,
    arrow: false,
    trigger: 'click',
    theme: 'light',
    maxWidth: 'none',
    placement: 'bottom-start',
    offset: [0, 0],
    // on open add class to toggle
    onShow(instance) {
      wrapper.classList.add('is-active');
    },
    onHide(instance) {
      wrapper.classList.remove('is-active');
    }
  });
};
componentSubMenuToggle();
